import i18next from 'i18next'
import React, { useState } from 'react'
import { cssTransition, toast, ToastContentProps } from 'react-toastify'

const offerionToast = (node: (props: ToastContentProps) => React.ReactNode, options?: { autoClose?: number | false }) => {
    toast(node, {
        bodyClassName: 'notification-body',
        className: 'notification-container',
        hideProgressBar: true,
        closeOnClick: false,
        autoClose: options?.autoClose,
        draggable: false,
        closeButton: false,
        transition: cssTransition({
            enter: 'zoomIn',
            exit: 'zoomOut',
            duration: [0, 500],
        }),
    })
}

const Header = ({ type }: { type: string }) => {
    return <h3 className={`notification__title notification__title--${type}`}>{i18next.t(`Popup.${type}Title`)}</h3>
}

const DetailsCollapse = ({ details }: { details: string | null }) => {
    const hasDetails = details !== null

    const [open, setOpen] = useState(false)

    if (!hasDetails) return null

    return (
        <div className="notification__details">
            <a className="pointer" onClick={() => setOpen(o => !o)} style={{ display: 'inline-flex', alignItems: 'center' }}>
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 10 10"
                    style={{
                        transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
                        transition: 'transform 150ms ease',
                        color: '#333',
                    }}
                >
                    <polygon points="3,1 3,9 8,5" fill="currentColor" />
                </svg>
            </a>
            {open && (
                <div className="notification__details-box">
                    <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{details ?? ''}</pre>
                </div>
            )}
        </div>
    )
}

export const toastSuccess = (messageKey: string, options?: {}) => {
    offerionToast(
        props => (
            <div className="notification">
                <a className="notification__close icono-cross pointer" onClick={props.closeToast}></a>
                <Header type="success" />
                <p className="notification__message" dangerouslySetInnerHTML={{ __html: i18next.t(messageKey, options) }}></p>
            </div>
        ),
        {
            autoClose: 2000,
        }
    )
}

export const toastInfo = (messageKey: string) => {
    offerionToast(props => (
        <div className="notification">
            <a className="notification__close icono-cross pointer" onClick={props.closeToast}></a>
            <Header type="info" />
            <p className="notification__message">{i18next.t(messageKey)}</p>
        </div>
    ))
}

export const toastWarning = (messageKey: string, skipTranslate?: boolean, autoClose?: number | false, options?: {}) => {
    offerionToast(
        props => (
            <div className="notification" style={{ whiteSpace: 'pre-line' }}>
                <a className="notification__close icono-cross pointer" onClick={props.closeToast}></a>
                <Header type="warning" />
                <p
                    className="notification__message"
                    dangerouslySetInnerHTML={{ __html: skipTranslate ? messageKey : i18next.t(messageKey, options) }}
                ></p>
            </div>
        ),
        {
            autoClose,
        }
    )
}

export const toastError = (messageKey: string, autoClose?: number | false, details: string | null = null) => {
    offerionToast(
        props => (
            <div className="notification">
                <a className="notification__close icono-cross pointer" onClick={props.closeToast}></a>
                <Header type="error" />
                <p className="notification__message" dangerouslySetInnerHTML={{ __html: i18next.t(messageKey) }}></p>
                <DetailsCollapse details={details} />
            </div>
        ),
        {
            autoClose,
        }
    )
}
